"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostUtils = void 0;
var _lodash = require("lodash");
var _useRequest3 = require("./useRequest");
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _constants = require("./constants");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useWordPressPosts = function useWordPressPosts() {
  var weekNumber = (0, _momentTimezone.default)().week() - 1;
  // We have 139 expert insights posts, want to feature 3 different ones each week.
  var offset = weekNumber > 45 ? weekNumber * 3 - 80 : weekNumber * 3;
  var _useRequest = (0, _useRequest3.useRequest)(
    // @TODO: 👉 When Ops adds the 'Featured' (or whatever is settled on) category,
    // find the id in wpengine, and add &categories=<id>.
    // 516 is the 'Expert Insights' category.
    {
      url: "".concat(_constants.MARKETING_SITE_URL, "/wp-json/wp/v2/posts?per_page=3&categories=516&offset=").concat(offset),
      withCredentials: false,
      withErrorsHandler: false
    }),
    _useRequest$data = _useRequest.data,
    wordPressResponse = _useRequest$data === void 0 ? [] : _useRequest$data,
    loading = _useRequest.loading;
  return {
    data: wordPressResponse && Array.isArray(wordPressResponse) ? wordPressResponse : [],
    loading: loading
  };
};

/**
 * @param {('thumbnail'|'full'|'medium'|'large'|'medium_large')} [size=thumbnail] - The size of an image
 */
var usePostImageSrc = function usePostImageSrc(id) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumbnail';
  var _useRequest2 = (0, _useRequest3.useRequest)(
    // @TODO: 👉 When Ops adds the 'Featured' (or whatever is settled on) category,
    // find the id in wpengine, and add &categories=<id>.
    // 516 is the 'Expert Insights' category.
    {
      url: "".concat(_constants.MARKETING_SITE_URL, "/wp-json/wp/v2/media/").concat(id),
      withCredentials: false,
      withErrorsHandler: false
    }, {
      ready: !!id
    }),
    _useRequest2$data = _useRequest2.data,
    media = _useRequest2$data === void 0 ? [] : _useRequest2$data;
  if (!media) {
    return null;
  }
  return (0, _lodash.get)(media.media_details, "sizes[".concat(size, "].source_url"), media.source_url);
};
var replaceEllipsis = function replaceEllipsis(text) {
  return text.replace(' [&hellip;]', '');
};
var sanitize = function sanitize(text) {
  return (0, _sanitizeHtml.default)(text);
};
var PostUtils = {
  replaceEllipsis: replaceEllipsis,
  sanitize: sanitize,
  useWordPressPosts: useWordPressPosts,
  usePostImageSrc: usePostImageSrc
};
exports.PostUtils = PostUtils;